import React from 'react';
import Layout from '../../components/UI/Layout/Layout';
import CurrenciesList from '../../components/Entity/Currencies/CurrenciesList';

const CurrenciesPage = () => (
  <Layout>
    <CurrenciesList />
  </Layout>
);

export default CurrenciesPage;
